import React from 'react'
import { _xtabNavItems } from '../../util/crosstabBetaUtils'
import NavButton from './NavButton'

const LeftNav = () => {

  const renderNav = () => {
    return _xtabNavItems.map(nav => {
      return (
        <div key={nav.id} className="crosstab2--nav--item">
          <NavButton
            location={nav.path}
            label={nav.title}
            icon={<nav.icon />}
          />
        </div>
      )
    })
  }

  return (
    <div className="crosstab2--nav--root">
      {renderNav()}
    </div>
  )
}

export default LeftNav